/* unplugin-vue-components disabled */import script from "./Sysmonitor.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sysmonitor.vue?vue&type=script&setup=true&lang=ts"

import "./Sysmonitor.vue?vue&type=style&index=0&id=8d71b4e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d71b4e0"]])

export default __exports__